var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DMorphLines12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 410,
    viewBox: "0 0 1440 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M526.421 9.25244C627.129 10.0917 725.822 27.1001 826.111 34.4294C926.818 41.7307 1025.85 27.7995 1125.83 16.6936C1203.12 66.544 1265.5 160.79 1355.55 178.721C1409.88 189.547 1426.16 244.965 1455.95 286.759C1490.19 334.763 1541.02 370.738 1585.31 409.286H-146.308C-34.1863 342.614 77.9351 275.942 190.057 209.269C245.586 176.064 298.709 146.159 345.622 100.897C368.142 79.1885 388.535 55.2424 416.565 40.36C450.666 22.2605 489.774 20.694 526.421 9.25244Z",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.623 367.856H1537.75",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.7793 331.657H1496.15",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7921 299.794C166.922 299.794 291.604 304.913 419.894 318.985C534.142 331.517 636.556 319.572 748.678 298.256C857.274 277.582 967.354 281.471 1077.46 277.135C1205.02 271.804 1332.79 276.706 1459.56 291.793",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3486 271.54C145.829 271.54 206.813 268.267 266.539 279.429C327.327 290.787 385.682 312.047 445.883 325.839C566.676 353.505 647.494 314.425 756.203 265.47C852.379 222.193 947.911 225.27 1051 215.871C1185.67 203.59 1295.75 203.45 1427.11 240.656",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.842 246.251C190.309 246.251 247.041 248.07 307.465 266.477C361.708 283.038 413.964 306.089 469.213 319.376C585.587 347.351 665.23 288.297 762.945 234.586C851.959 185.631 943.072 190.778 1041.32 179.644C1168.88 165.209 1274.37 156.509 1398.05 198.499",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.026 223.564C278.791 224.151 379.891 266.197 490.054 281.891C594.007 296.661 675.384 249.496 768.987 212.626C855.484 178.581 941.197 181.239 1032.48 173.77C1148.74 164.202 1256.94 154.188 1371.97 180.763",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.575 203.003C304.332 205.801 405.544 230.11 509.049 234.614C601.113 238.614 685.428 213.969 774.498 195.45C857.162 178.386 940.582 181.659 1024.53 177.966C1132.79 173.238 1240.36 166.217 1348.42 177.686",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.878 184.064C415.894 186.47 595.545 192.456 779.421 181.267C960.359 170.468 1145.89 173.182 1326.99 176.763",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.439 167.503C609.448 167.335 958.457 167.335 1307.47 167.503",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M286.624 151.25C453.799 146.495 620.89 144.788 788.121 142.55C955.352 140.312 1122.25 151.922 1289.59 151.922",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.682 132.983C470.947 120.143 631.24 116.198 791.841 110.939C954.093 105.624 1111.48 137.711 1273 137.543",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M332.893 113.205C486.417 92.3645 640.78 87.2172 795.45 78.769C954.736 70.0689 1100.37 121.822 1258.01 124.339",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.428 93.1756C500.098 66.3201 649.956 60.4735 798.696 49.9272C869.444 44.9198 935.1 45.731 1004.64 62.4317C1084.79 81.7061 1161.1 106.967 1243.96 112.142",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.478 74.2091C512.573 44.0806 658.908 38.9333 801.717 26.9323C867.876 21.3374 928.077 21.1976 992.502 38.4858C1072.73 60.0261 1147.68 90.9657 1230.96 100.393",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M390.214 57.6759C524.127 27.2957 667.524 22.8198 804.543 10.9867C864.352 5.81139 922.035 4.44065 980.781 19.9105C1061.52 41.227 1135.62 76.6706 1218.93 89.1752",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M406.746 45.0874C536.603 18.3159 674.825 14.7911 807.144 4.04897C952.611 -7.7842 1067.53 52.2768 1207.54 77.7615",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M422.216 36.2476C548.716 14.3437 681.371 12.2456 809.605 4.02113C947.827 -4.73486 1063.19 42.8216 1196.97 67.2153",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M436.707 30.289C560.018 13.5044 687.498 13.5044 811.9 8.18926C942.932 2.59438 1058.97 37.5624 1187.09 58.1516",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M450.331 26.4008C570.621 14.2879 693.261 16.7776 813.998 14.4557C938.345 12.0779 1054.86 35.0729 1177.67 50.5148",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M463.115 23.883C698.492 8.02149 934.764 24.4425 1169.05 44.1644",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M475.2 22.1206C702.604 13.1408 933.533 29.5898 1160.8 38.9052",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M486.585 20.5817C708.31 16.8332 930.902 34.3452 1153.02 34.1214",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M497.355 18.8477C605.896 18.7078 713.262 30.513 821.495 36.5275C929.728 42.542 1037.88 33.9818 1145.66 29.8416",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M507.538 16.5259C613.421 17.2532 717.682 31.1565 823.118 38.0382C928.553 44.9199 1033.74 32.9469 1138.7 25.6176",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M517.217 13.3645C620.526 14.3716 721.822 29.9533 824.655 37.2826C927.489 44.6119 1029.71 30.9324 1132.09 21.2533",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.75 19.0432C1147.51 46.0945 1178.84 76.9222 1214.45 115.023C1227.88 129.402 1242.17 147.278 1258.23 158.775C1282.85 176.399 1281.67 169.042 1310.74 171.7C1363.27 176.455 1372.87 224.124 1395.75 267.652C1425.94 325.111 1472.57 364.919 1518.84 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.7 21.7008C1121.8 44.6118 1145.61 64.6694 1174.42 103.806C1187.06 120.954 1199.76 142.214 1216.16 156.174C1240.19 176.623 1240.22 163.867 1265.9 168.287C1290.9 172.567 1282.88 157.712 1305.62 180.232C1327.33 201.744 1334.35 242.587 1346.8 269.75C1372.73 326.258 1410.08 364.163 1452.09 409.314",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.59 24.3864C1103.31 46.3183 1117.58 58.3753 1144.99 105.093C1155.9 126.074 1168.89 145.906 1183.76 164.286C1195.31 179.076 1207.73 180.129 1221.03 167.447C1234.88 153.777 1247.3 155.428 1258.29 172.399C1273.4 207.134 1286.38 242.755 1297.17 279.065C1317.45 331.182 1350.57 366.709 1385.57 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.6 27.0441C1047.53 31.9849 1061.88 35.6461 1076.48 37.9821C1093.55 58.6839 1106.58 82.407 1114.89 107.918C1123.58 130.974 1135.56 152.647 1150.47 172.259C1160.58 177.071 1169.18 175.756 1176.27 168.315C1183.28 161.153 1191.87 159.4 1202.03 163.056C1219.13 193.802 1231.15 227.111 1237.61 261.693C1256.05 320.971 1283.46 359.464 1318.91 409.147",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.55 29.5898C1023.35 31.7743 1036.38 32.3288 1049.32 31.2403C1065.32 56.6863 1076.98 84.6112 1083.84 113.877C1089.27 127.92 1094.67 141.963 1100.06 156.006C1105.88 177.602 1116.34 182.461 1131.42 170.581C1142.61 158.906 1150.44 160.165 1154.89 174.357C1170.71 194.272 1179.22 219.005 1179.01 244.433C1196.3 308.774 1218.37 353.142 1252.3 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M987.494 31.9117C998.837 32.324 1010 29.0022 1019.27 22.4563C1037.4 61.4806 1038.86 119.695 1060.87 154.831C1097.49 213.074 1076.93 143.893 1099.36 167.671C1131.34 201.548 1125.86 268.016 1139.42 309.166C1150.89 343.994 1169.5 376.584 1185.69 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M964.444 33.8976C974.688 29.9571 983.811 23.5705 991.02 15.2947C1000.06 46.0665 1005.01 145.544 1025.62 167.336C1038.52 181.043 1043.56 167.336 1052.54 177.406C1072.51 199.786 1075.31 275.596 1080.51 297.444C1089.6 336.049 1104.9 372.388 1119.17 409.342",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M941.393 35.4922C948.611 27.0999 955.38 18.7076 961.954 9.72778C969.172 52.6685 962.514 122.409 984.334 156.565C980.716 170.068 983.513 177.043 992.726 177.49C996.856 178.409 1001.06 178.952 1005.29 179.113C1019.89 208.654 1017.85 251.846 1022.6 283.485C1029.15 327.013 1040.76 367.073 1052.48 409.37",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M918.342 36.5834C923.243 25.9675 927.421 15.0326 930.847 3.85339C944.834 142.606 962.43 270.338 985.9 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M895.263 37.2269C897.128 25.1979 898.62 13.1222 899.739 1C904.607 137.627 911.097 272.771 919.321 409.426",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M872.213 36.8071C870.702 24.9646 869.499 13.1034 868.604 1.22363C864.632 137.431 859.345 273.107 852.715 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M849.162 35.8281C844.465 25.1274 840.566 14.0941 837.496 2.81836C824.572 139.333 807.62 273.555 786.107 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M826.11 34.4292C818.707 25.2942 812.1 15.5421 806.36 5.27979C784.323 141.343 755.331 276.188 719.5 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M803.06 32.415C791.893 26.5818 782.856 17.3683 777.24 6.09106C753.769 86.9651 742.831 169.685 717.542 250.392C700.534 304.69 673.007 355.715 652.894 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M780.009 30.1493C773.476 29.2291 767.251 26.7812 761.842 23.0046C756.432 19.2279 751.989 14.2289 748.873 8.41321C709.709 87.0772 698.24 188.289 670.545 272.855C651.858 329.895 653.62 291.934 631.381 322.258C612.442 348.05 599.938 380.752 586.118 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M756.957 27.6316C749.825 27.6241 742.77 26.1557 736.226 23.3171C729.683 20.4785 723.791 16.3298 718.912 11.1267C669.621 94.1547 657.061 203.646 622.988 294.032C595.601 366.765 612.917 309.11 575.04 323.433C556.912 330.287 527.763 395.579 519.65 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M733.908 24.9459C726.458 26.3618 718.784 26.0597 711.469 24.0625C704.154 22.0653 697.391 18.4256 691.694 13.4204C669.706 31.7716 657.109 55.8297 653.901 85.5944C634.878 140.48 611.939 192.876 593.504 248.014C586.268 274.589 577.801 300.783 568.103 326.594C557.231 343.919 545.565 344.637 533.107 328.748C514.458 318.714 501.851 325.522 495.286 349.169L453.101 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M710.857 22.2042C703.201 24.6277 695.096 25.2851 687.15 24.1271C679.204 22.9692 671.624 20.0259 664.979 15.5183C641.629 27.0251 627.866 46.486 623.688 73.9009C598.511 133.039 569.418 190.442 548.661 251.203C542.587 281.491 530.06 310.114 511.931 335.126C505.096 335.99 498.156 335.405 491.563 333.41C484.969 331.415 478.87 328.053 473.662 323.545C436.12 327.125 408.761 381.787 386.493 409.23",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M687.777 19.519C663.551 30.3451 648.976 12.973 627.296 22.792C603.826 33.4502 594.538 65.7607 583.824 87.5807C556.884 142.047 527.875 193.408 503.901 249.217C493.718 272.827 485.634 321.111 454.75 326.986C442.161 329.363 426.496 316.551 413.516 318.901C379.079 325.195 342.181 385.116 319.941 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M664.726 16.9172C641.032 28.7784 623.296 15.0989 600.609 22.5121C570.089 32.527 557.137 71.6632 543.121 98.2668C516.63 148.397 484.711 194.135 459.002 244.825C446.89 268.743 434.105 301.333 407.082 310.341C392.731 315.124 378.38 310.341 363.778 314.257C321.312 325.867 284.638 378.794 253.307 409.37",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M641.676 14.5671C613.897 29.2537 588.888 11.406 561.557 25.2254C539.681 36.4151 525.191 68.1101 513.581 87.8041C483.061 139.585 447.617 187.449 414.188 237.327C376.814 293.108 355.442 284.101 303.018 311.264C260.077 333.447 222.675 377.647 186.7 409.174",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M618.625 12.5253C590.65 26.0369 561.697 12.0496 534.953 24.0786C504.965 37.5623 489.747 73.7612 472.682 99.2738C441.659 145.543 405.18 187.281 369.373 229.998C335.412 270.505 297.479 277.135 254.062 302.983C206.506 331.294 163.257 374.654 120.093 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M595.574 10.9026C567.292 19.6586 535.345 13.7 508.658 24.4702C478.446 36.8069 462.22 68.6138 443.701 93.1753C407.978 140.732 368.618 181.714 324.53 221.578C285.59 256.77 235.572 275.932 192.855 306.424C145.914 339.993 99.9238 375.017 53.4863 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M572.634 9.75574C543.205 19.1272 511.09 15.3506 482.752 26.2886C447.448 40.08 425.097 78.1252 402.354 105.792C367.693 148.033 324.529 183.84 279.826 215.284C184.461 282.422 83.5293 343.351 -12.9824 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M549.471 9.25244C519.231 18.8756 486.081 17.6447 456.848 29.0583C420.901 43.1854 398.857 75.272 373.736 102.603C333.033 146.859 285.477 178.61 234.871 210.528C129.948 276.678 25.0909 342.931 -79.7012 409.286",
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 0.692148,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DMorphLines12);
export default __webpack_public_path__ + "static/media/3D Morph Lines 12.ec0374a284ffc9b6d17a2a6734b7bb42.svg";
export { ForwardRef as ReactComponent };